import { Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { EndpointFactory } from './endpoint-factory.service';
import { ConfigurationService } from './configuration.service';
import { InstitutionInfo } from '../models/institution-info.model';
import { ErrorHandleService } from './error-handle.service';

@Injectable({
  providedIn: 'root'
})

export class InstitutionInfoEndpoint extends EndpointFactory {

  private readonly _baseUrl: string = "/api/VacantBedsInfo/";

  get baseUrl() { return this.configurations.baseUrl + this._baseUrl; }

  constructor(http: HttpClient, configurations: ConfigurationService,
    errorHandleService: ErrorHandleService, injector: Injector) {

    super(http, configurations, errorHandleService, injector);
  }

  getInstitutionInfoEndpoint<T>(id: number): Observable<T> {
    let endpointUrl = `${this.baseUrl}GetInstitution/${id}`;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.errorHandleService.handleError(error, () => this.getInstitutionInfoEndpoint(id));
      }));
  }

  updateInstitutionInfoEndpoint<T>(institutionInfo: InstitutionInfo): Observable<T> {
    let endpointUrl = `${this.baseUrl}UpdateInstitution`;

    return this.http.post<T>(endpointUrl, institutionInfo, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.errorHandleService.handleError(error, () => this.updateInstitutionInfoEndpoint(institutionInfo));
      }));
  }
}
